import type { ReportDashboard, ReportDashboardApiEntity } from '@core/reports-types';

export const dashboardApiEntityToDashboard = (
  dashboardApiEntity: ReportDashboardApiEntity,
): ReportDashboard => {
  const { components, ...dashboard } = dashboardApiEntity;

  return {
    ...dashboard,
    componentIds: components.map(c => c.id ?? c.localId),
    filters: dashboard.filters ?? [],
    dateFilter: dashboard.dateFilter ?? {
      dateRange: null,
      dateStart: null,
      dateEnd: null,
    },
  };
};
